<template>
  <div>
    <div style="width: 90%">
      <b-card bg-variant="light">
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Username" label-for="input-sm">
          <b-form-input id="username" size="md" v-model="userName"></b-form-input>
        </b-form-group>


        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Password" label-for="input-sm">

          <b-form-input type="password" id="text-password" aria-describedby="password-help-block"
                        v-model="password" size="md" @keyup.enter="login"></b-form-input>
          <b-form-text id="password-help-block">
            Your password must be 8-20 characters long, contain letters and numbers, and must not
            contain spaces, special characters, or emoji.
          </b-form-text>

        </b-form-group>
        <div class="button-holder">
          <b-button class="submit-button" type="submit" @click="login" variant="primary" @keyup.enter="login">
            Login
          </b-button>
        </div>
        <div>
          <b-row style="padding-top: 10px">
            <b-col cols="2"></b-col>
            <b-col style="text-align: right; font-size: 10pt" cols="4">
              <router-link to="request-winery-account">Request Napa Green Winery Account</router-link>
            </b-col>
            <b-col style="text-align: left; font-size: 10pt" cols="4">
              <router-link to="request-vineyard-account">Request Napa Green Vineyard Account</router-link>
            </b-col>
            <b-col cols="2"></b-col>
          </b-row>
          <b-row style="padding-top: 10px">
            <b-col cols="4"></b-col>

            <b-col style="text-align: center; font-size: 10pt" cols="4">
              <router-link to="forgot-password">Forgot My Password</router-link>
            </b-col>
            <b-col cols="4"></b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>

</template>

<script>
import Bus from "../eventBus";
import Swal from 'sweetalert2';

export default {
  name: "Login.vue",
  components: {},
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('user')) {
      next(vm => {
        vm.determineLanding()
      });
    }
    next();
  },
  data() {
    return {
      userName: '',
      darkMode: false,
      password: ''
    }
  },
  mounted() {
    Bus.$emit('show-sidebar', false);
  },
  computed: {
    validation() {
      return this.userName.length > 4 && this.userName.length < 13
    }
  },
  methods: {
    determineLanding: function () {
      if (localStorage.getItem('roles').includes('admin')) {
        this.$router.push("/questionnaire-admin");
      } else {
        this.$router.push("/my-account");
      }
    },
    submit: function () {
      console.log("Logging in.");
      localStorage.clear();
      this.$router.push({path: '/my-account'});
    },
    login: async function () {
      let self = this;
      if (this.username !== "" && this.password !== "") {
        this.$http.post("auth/login", {
              username: this.userName,
              password: this.password
            },
            {
              headers: {
                'content-type': 'application/json'
              }
            })
            .then(result => {
              if (result.status === 200) {
                let token = result.data;
                localStorage.setItem('user', token.name);
                this.$store.commit('user/user', token.name);

                localStorage.setItem('groups', token.groups);
                this.$store.commit('user/groups', token.groups);

                localStorage.setItem('roles', token.roles);
                this.$store.commit('user/roles', token.roles);

                localStorage.setObject('groupRoles', token.claims.groupRoles);
                this.$store.commit('user/groupRoles', token.claims.groupRoles);

                localStorage.setItem('tokenExpiration', token.claims.exp);
                this.$store.commit('user/tokenExpiration', token.claims.exp);

                if (token.roles.indexOf("admin") > -1 || token.roles.indexOf("THIRD_PARTY_CERTIFIER") > -1 ||
                    token.roles.indexOf("VINEYARD_ADMIN") > -1) {
                  Bus.$emit('show-sidebar', true)
                }
              }
            })
            .then(() => this.$http.get(`account/user/id/${localStorage.getItem('user')}/groups`,
                {
                  headers: {
                    'content-type': 'application/json'//,
                  }
                })
                .then(result => {
                  let options = [];

                  if (result.data.length < 2) {
                    localStorage.setItem('multiGroupUser', 'false');
                    this.$store.commit('user/multiGroupUser', false);

                    localStorage.setItem('groupName', result.data[0].name);
                    this.$store.commit('user/groupName', result.data[0].name);

                    localStorage.setItem('entityType', result.data[0].entityType)
                    this.$store.commit('user/entityType', result.data[0].entityType);

                    Bus.$emit('group-update', result.data[0].name);
                    Bus.$emit("update-entityType", result.data[0].entityType)
                    return {value: result.data[0]._id};
                  }
                  result.data.forEach(item => {
                    options[item._id] = item.name + '(' + item.entityType + ')'
                    /*name: item.name,
                    type: item.entityType*/
                  });
                  localStorage.setItem('multiGroupUser', 'true');
                  this.$store.commit("user/multiGroupUser", true, {root: true})

                  let winery = Swal.fire({
                    title: 'Select Organization to Continue',
                    input: 'select',
                    inputOptions: options,
                    inputPlaceholder: 'Select A Organization',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    inputValidator: (value) => {
                      return new Promise((resolve) => {
                        if (value !== '') {
                          this.$store.commit('user/groupName', options[value]);
                          this.$store.commit('user/entityType', self.extractEntityType(options[value]));
                          Bus.$emit('group-update', options[value]);
                          Bus.$emit('update-entityType', self.extractEntityType(options[value]));
                          localStorage.setItem("entityType", self.extractEntityType(options[value]))
                          resolve()
                        } else {
                          resolve('You must select a winery.')
                        }
                      })
                    }
                  });
                  result.data.forEach(val => {
                    if (val._id === winery.value) {
                      console.log("Swal Select Organization")
                      localStorage.setItem("groupName", val.name);
                      this.$store.commit('user/groupName', val.name);
                      localStorage.setItem("orgType", val.entityType);
                      this.$store.commit('user/entityType', val.entityType);
                      localStorage.setItem("county", val.county);
                      this.$store.commit("user/currentCounty", val.county, {root: true})
                    }
                  });
                  return winery;
                }))
            .then(grouper => {
              console.log(grouper);
              localStorage.setItem('groupId', grouper.value);
              this.$store.commit("user/groupId", grouper.value, {root: true})
              this.$store.dispatch("user/updateGroupInfo", grouper.value, {root: true})
            })
            .then(() => {
              let returnUrl = self.$route.query.returnUrl;
              if (returnUrl !== '' && returnUrl !== undefined) {
                this.$router.push({path: returnUrl});
              } else {
                if (localStorage.getItem('roles').includes('admin') || localStorage.getItem('roles').includes('VINEYARD_ADMIN')) {
                  this.$router.push("/questionnaire-admin");
                } else if (localStorage.getItem('entityType') === "VINEYARD") {
                  this.$router.push("/vineyard-page");
                } else {
                  this.$router.push("/my-account");
                }
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire({
                title: 'Login Failure',
                text: 'Please verify your username and password and try again.',
                icon: 'error'
              });
            });
      } else {
        await Swal.fire({
          title: 'Login Failure',
          text: "A username and password are required.",
          icon: 'error'
        });
      }
    },
    extractEntityType: function (groupName) {
      let firstIndex = groupName.indexOf("(") + 1;
      let lastIndex = groupName.indexOf(")");
      return groupName.substring(firstIndex, lastIndex);
    }
  }
}
</script>

<style scoped>
.submit-button {
  margin-left: 10px;
  margin-top: 5px;
}

.button-holder {
  horiz-align: center;
  display: flex; /*Requires vendor prefixes*/
  justify-content: center; /*Requires vendor prefixes*/
  align-items: center; /*Requires vendor prefixes*/
}

.swal2-title {
  font-size: 16px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.21);
  margin: 0 0 28px;
}

.swal2-popup {
  font-size: 1.6rem !important;
}
</style>
